export const environment = {
  production: false,
  pulseWizardStateDebugOverlay: true,
  /** TSF-1785: gates the copy-across-environments analyze/confirm entry points. */
  copyDependentsEnabled: true,
  dbJsonConfigFile: 'db_reports.test.json',
  apiBaseUrl: '',
  processLogApiBasePath: '/api/v1/process-logs',
  processLogWsPath: '/api/v1/process-logs/ws',
  dcEnvironments: ['test'],
  dscoEnvironments: ['test', 'staging'],
  orderstreamEnvironments: ['lchan','PT-lowesca1024','PT-spicy23809_iris'],
  partnerTestRedirectUrl: '',
  rtbfEnvironments: ['dev'],
  pulseEnvironments: ['test', 'dev'],
  processLogEnvironments: ['test'],
  pulseCupAdapterEnvironments: ['test'],
  pulseOSAdapterEnvironments: ['dev'],
  searchBuckets: [
    { locationName: 'arcfs-archive', locationType: 'bucket', locationDisplayName: 'ArcFS Archive' },
    { locationName: 'arcfs-archive24', locationType: 'bucket', locationDisplayName: 'ArcFS Archive 24' },
    { locationName: 'livefs-archive24', locationType: 'bucket', locationDisplayName: 'LiveFS Archive 24' },
  ],
  optiksEnvironments: ['test', 'staging'],
  notificationServiceEnvironments: ['dev', 'test'],
  /** TSF-2013: Pulse environments with multi-destination internal connections enabled. */
  internalMultiDestinationEnvironments: ['test', 'dev'],
};
